import { toast } from '@/helpers/toast/toast.helper'
import { MessageModel } from '@/models/message.model'
import { updateActiveChatAction } from '@/redux/chat/actions'
import { saveMany } from '@/redux/chat/sagas/_http/message'
import { buildOfficialMessage } from '@/redux/chat/sagas/createNewChatSaga/helpers'
import { Chat } from '@/redux/chat/types'
import { t } from 'i18next'
import { put } from 'redux-saga/effects'
import { createMessageAsync, CreateMessageRequestParam } from '../../actions'
import { buildUnOfficialMessage } from './helpers'
import { buildFilesData, buildUnOfficialFilesData, sendMessage, sendMessageOfficialAPI } from './http/message'
import { SendMessageOfficialAPIResponse, SendMessageResponse } from './http/message/types'
import { update } from '@/redux/chat/sagas/_http/chat'

export function* createMessageSaga(action: ReturnType<typeof createMessageAsync.request>) {
  const { message, isOfficial, ownerId, campanhaId, phoneNumberId, token, typeFile } = action.payload
  try {
    const newMessage: MessageModel = yield createNewMessage({ message, ownerId, typeFile })
    if (isOfficial) {
      const sendMessageOfficialAPIResponse: SendMessageOfficialAPIResponse = yield sendMessageOfficialAPI({
        campaignId: campanhaId,
        messageId: newMessage?.templateMessageId,
        phone: newMessage.phone,
        typeSent: newMessage.messageTypeSent,
        phoneNumberId,
        text: newMessage.messageText,
        messageType: newMessage.typeFile === 'contact' ? 'text' : newMessage.typeFile,
        caption: newMessage.messageText || '',
        isRetryMessage: message?.isQuickReply || false,
        filesData: buildFilesData(newMessage.files, message?.isQuickReply || false),
        contactBusinessDescription: newMessage.contactsMessage?.length
          ? newMessage.contactsMessage[0].name?.description
          : '',
        contactName: newMessage.contactsMessage?.length ? newMessage.contactsMessage[0].name?.formatted_name : '',
        contactPhone: newMessage.contactsMessage?.length ? newMessage.contactsMessage[0]?.phones[0]?.phone : '',
        name: newMessage?.location?.name || '',
        latitude: newMessage?.location?.latitude?.toString() || '',
        longitude: newMessage?.location?.longitude?.toString() || ''
      })
      const sendedMessages = buildOfficialMessage(newMessage, sendMessageOfficialAPIResponse)
      yield saveMany(sendedMessages)
      yield updateChatWithNewMessage(sendedMessages[sendedMessages.length - 1])
    } else {
      const sendMessageResult: SendMessageResponse = yield sendMessageToZApiMultiService(newMessage, campanhaId, token)
      const sendedMessages = buildUnOfficialMessage(newMessage, sendMessageResult)

      yield updateChatWithNewMessage(sendedMessages[sendedMessages.length - 1])
      yield saveMany(sendedMessages)
    }
    yield put(createMessageAsync.success())
    action.payload.onSuccess?.()
  } catch (error) {
    console.log('createMessage error', JSON.stringify(error))
    toast({ type: 'error', message: t('translation:sendMessageError') })
    yield put(createMessageAsync.failure(error))
    action.payload.onFailure?.(error)
  }
}

export async function sendMessageToZApiMultiService(newMessage: MessageModel, campaignId: string, token: string) {
  return await sendMessage({
    campaignId,
    token,
    typeFile: newMessage.typeFile,
    body: {
      phone: newMessage.phone,
      message: newMessage.messageText,
      contactsMessage: newMessage?.contactsMessage,
      messageId: newMessage?.replyMessage?.messageId ? newMessage.replyMessage.messageId : '',
      fromMe: newMessage.fromMe,
      templateId: '',
      caption: newMessage.messageText || '',
      filesData: buildUnOfficialFilesData(newMessage.files)
    }
  })
}

async function createNewMessage({ message }: Partial<CreateMessageRequestParam>): Promise<MessageModel> {
  return {
    ...message,
    messageId: '',
    isRead: false,
    isSend: true,
    fromMe: true
  } as MessageModel
}

function* updateChatWithNewMessage(newMessage: MessageModel) {
  const updatedChatData: Partial<Chat> = {
    lastMessage: newMessage
  }

  yield update(newMessage.chatId, updatedChatData)
  yield put(updateActiveChatAction(updatedChatData))
}
